import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description HobbiesCreativity icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { HobbiesCreativity } from '@sravni/design-system-icons'
 *
 * <HobbiesCreativity />
 * ```
 */
var HobbiesCreativity = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "HobbiesCreativity", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { clipRule: "evenodd", d: "M10.736 2.5h-7.5a.834.834 0 0 0-.834.833v13.334c0 .46.374.833.834.833h7.5c.92 0 1.666-.746 1.666-1.667V4.167c0-.921-.745-1.667-1.666-1.667Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m15.876 15.21 1.52 2.275h.014l1.52-2.275a.836.836 0 0 0 .14-.463V4.168a1.666 1.666 0 1 0-3.334 0v10.58c0 .165.05.326.14.463ZM15.736 5.833h3.334M5.736 2.5v15M9.07 13.333V15", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { HobbiesCreativity };
//# sourceMappingURL=HobbiesCreativity.js.map
